import {
    Component,
    Input,
    OnInit,
    ViewChild,
    EventEmitter,
    Output
} from '@angular/core';
import { QuillEditorComponent, QuillModule } from 'ngx-quill';
import { FormGroup} from '@angular/forms';
import Quill from 'quill';
import 'quill-mention';
import {CsTaggingService} from "@app/directives/material-directives/cs-tagging/cs-tagging.service";

declare var $;

const FontStyle = Quill.import('attributors/style/font');
FontStyle.whitelist = [
    'Arial, sans-serif',
    'Courier New, monospace',
    'Georgia, serif',
    'Tahoma, sans-serif',
    'Times New Roman, serif',
    'Trebuchet MS, sans-serif',
    'Verdana, sans-serif'
];
Quill.register(FontStyle, true);

const Size = Quill.import('attributors/style/size');
Size.whitelist = [false, '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px'];
Quill.register(Size, true);

const setDefaultCssProperties = () => {
    const Block = Quill.import("blots/block");
    class Pblock extends Block {
        static create(value) {
            let node = super.create();
            node.setAttribute(
                "style",
                "margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;"
            );
            return node;
        }
    }
    Quill.register(Pblock, true);
};
setDefaultCssProperties();
/*
let Delta = Quill.import('delta');
let Break:any = Quill.import('blots/break');
const Embed = Quill.import('blots/embed');

const lineBreakMatcher = () => {
    let newDelta = new Delta();
    newDelta.insert({ break: "" });
    return newDelta;
};
class SmartBreak extends Break {
    length () {
        return 0
    }
    value () {
        return '\n'
    }
    insertInto(parent, ref) {
        Embed.prototype.insertInto.call(this, parent, ref)
    }
}

SmartBreak.blotName = 'break';
SmartBreak.tagName = 'BR';
Quill.register(SmartBreak)
*/


@Component({
  selector: 'quill-editor-custom',
  templateUrl: './quill-editor-custom.component.html',
  styleUrls: ['quill-editor-custom.component.scss']
})
export class QuillEditorCustomComponent implements OnInit {
    @Input() public form: FormGroup;
    @Input() public lableName;
    @Input() private uploadCommunication: EventEmitter<string>;
    @Input() fieldControlName;
    @Input() screen: string;
    // Dial Pad only - drives the exact same plain-text tag flow normally triggered by '[',
    // just keyed on '@' instead. Never true alongside opportunity_notes/opportunity_call_log/
    // scheduledActivities, which already use '@' for a different (chip-style mention) flow.
    @Input() dialPad: boolean = false;
    @Input() set tagsList(tags:any[]) {
        if (tags && tags.length) {
            this._tagsList = tags;
            if ( $('.ql-mention-loading').length > 0) {
                this.editors.quillEditor.getModule('mention').openMenu("");
            }
        }
    };
    @Input() set customTagsList(tags:any[]) {
        this.doNotShowLoading = false;
        if(tags.length) {
            this.customTagList = tags;

            if( $('.ql-mention-loading').length > 0) {
                this.editors.quillEditor.getModule('mention').openMenu("");
            }
            let $mentionWrap = $('span.mention');
            tags.forEach((tag) => {
                    if (tag.denotationChar === '{') {
                        if (!tag['value'].includes('{')) {
                            tag['value'] = '{' + tag['value'] + '}';
                        }
                        if(tag.new) {
                            this.onSelectTagHandler(tag);
                            delete tag.new;
                        }
                    }
            });
        }
    };
    @Output() contentChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() configureCustomData: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(QuillEditorComponent) editors: QuillEditorComponent;
    _tagsList:any[] = [];
    customTagList: any[] = [];
    csTaggingList: any[] = [];
    initialLoad: boolean = false;
    communicatioType:string;
    doNotShowLoading = false;
    module: any;
    modulesMessage: QuillModule;
    modulesSubject: QuillModule;
    placeHolder = 'To use tags, type \'[\' and choose from the list of tags';
    constructor( private tagService: CsTaggingService) { }

    // Default/fallback tag-flow trigger char - '[' everywhere except Dial Pad, which uses '@'
    // for the identical flow.
    get tagChar(): string {
        return this.dialPad ? '@' : '[';
    }

    ngOnInit() {
        if(this.screen === 'opportunity') this.screen = 'opportunity_notes';
        this.module = {
            mentionListClass: 'ql-mention-list mat-elevation-z8',
            defaultMenuOrientation: 'bottom',
            allowedChars: /^[A-Za-z0-9\sÅÄÖåäö\_\}\?]*$/,
            fixMentionsToQuill: false,
            showDenotationChar: false,
            spaceAfterInsert: this.screen === 'call_note_template' || this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities'? true : false,
            isolateCharacter: false,
            selectKeys: [13, 221],
            renderItem: (data) => {
                if (data.disabled) {
                    return `<div style="background-color:#ddd;margin:0 -14px;padding:2px 8px; font-weight: bold; pointer-events: none; color:#999;">${data.value}</div>`;
                } else if(data.text) {
                    return data.text;
                }
                return data.value;
            },
            onSelect: (item: DOMStringMap, insertItem) => {
                if (item.denotationChar === this.tagChar) {
                    item['value'] = '['+item['value'] + ']';
                    this.onSelectTagHandler(item);
                }
                if(this.screen === 'call_note_template') {
                    if (item.denotationChar === '{') {
                        if(!this.customTagList.length) {
                            this.configureCustomData.emit({...item, action: 'add'});
                        } else {
                            const existingCt = this.customTagList.find(ct => ct.value == item.value)
                            if(!existingCt) {
                                this.configureCustomData.emit({...item, action: 'add'});
                            } else {
                                this.onSelectTagHandler(item);
                            }
                        }
                    }
                } else if (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities') {
                    item['value'] = item['value'];
                    this.onSelectTagHandler(item);
                }
            },
            renderLoading: (data) => {
                if(!this.customTagList.length || this.doNotShowLoading) {
                    return;
                }
                return "Loading...";
            },
            mentionDenotationChars: this.screen === 'call_note_template' ? ['{'] : (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities') ? ['@'] : [this.tagChar],
            source: (searchTerm, renderList, mentionChar) => {
                let values = [];
                if(mentionChar == this.tagChar) {
                    if (searchTerm.length === 0) {
                        values = this._tagsList;
                    } else {
                        const matches = [];
                        values = this._tagsList;
                        for (let i = 0; i < values.length; i++) {
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                                matches.push(values[i]);
                            }
                        }
                        values = matches;
                        if (matches.length === 0) {
                            values.push({
                                id: 0,
                                value: "No tag found...",
                                disabled: true
                            });
                        }
                    }
                    if (values.length) {
                        renderList(values, searchTerm);
                    }
                } else if (mentionChar == '{' && this.screen === 'call_note_template') {
                    if (searchTerm.length === 0) {
                        values = this.customTagList;
                    } else {
                        const matches = [];
                        values = this.customTagList;
                        for (let i = 0; i < values.length; i++) {
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                                matches.push(values[i]);
                            }
                        }
                        values = matches;
                        if (matches.length === 0) {
                            if (searchTerm.includes('}')) {
                                const name = searchTerm.slice(0, searchTerm.length - 1);
                                this.doNotShowLoading = true;
                                this.configureCustomData.emit({name, denotationChar: '{', value: name, action: 'add'});
                            } else {
                                values.push({
                                    id: 0,
                                    text: "Press enter to add new custom tag",
                                    value: searchTerm
                                });
                            }
                        }
                    }
                    renderList(values, searchTerm);
                } else if (mentionChar == '@' && (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities')) {
                    if (searchTerm.length === 0) {
                        values = this._tagsList;
                    } else {
                        const matches = [];
                        values = this._tagsList;
                        for (let i = 0; i < values.length; i++) {
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                                matches.push(values[i]);
                            }
                        }
                        values = matches;
                        if (matches.length === 0) {
                            values.push({
                                id: 0,
                                value: "No values found...",
                                disabled: true
                            });
                        }
                    }
                    if (values.length) {
                        renderList(values, searchTerm);
                    }
                }
            }};

        this.modulesMessage = {
            mention: this.module,
            /*clipboard: {
                 matchers: [
                     ['BR', lineBreakMatcher]
                 ],
                // matchVisual: true,
             },
             keyboard: {
                 bindings: {
                     linebreak: {
                         key: 13,
                         shiftKey: true,

                         handler: function (range) {
                             let currentLeaf = this.quill.getLeaf(range.index)[0]
                             let nextLeaf = this.quill.getLeaf(range.index + 1)[0];
                             this.quill.insertEmbed(range.index, "break", true, "user");
                             if (nextLeaf === null || currentLeaf.parent !== nextLeaf.parent) {
                                 this.quill.insertEmbed(range.index, "break", true, "user");
                             }
                             // Now that we've inserted a line break, move the cursor forward
                             this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
                         }
                     }
                 }
             },*/
            toolbar: {
                container: [
                    ['bold', 'italic', 'underline'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                    [{ font:  [
                            'Arial, sans-serif',
                            'Courier New, monospace',
                            'Georgia, serif',
                            'Tahoma, sans-serif',
                            'Times New Roman, serif',
                            'Trebuchet MS, sans-serif',
                            'Verdana, sans-serif'
                        ] }],
                    [{ size: [ false, '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px']}],
                    ['link']
                ]
            }
        };
        this.modulesSubject = {
            mention: this.module,
            toolbar: false
        };
        if(this.uploadCommunication) {
            this.uploadCommunication.subscribe(data => {
                if (data === 'sms' || this.lableName === 'subject') {
                    this.initialLoad = true;
                }
                this.communicatioType = data;
            });
        }
        window.addEventListener('mention-clicked', (event: any) => {
            const editableCT = this.customTagList.find((ctl) => ctl.value == event.value.value);
            this.configureCustomData.emit({...editableCT, action: 'edit', denotationChar: '{' });
        }, false);

        if (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities') {
            this.modulesMessage['toolbar'] = false;
            this.modulesMessage['keyboard'] = {
                bindings: {
                    bold: null,
                    italic: null,
                    underline: null,
                    strike: null,
                    blockquote: null,
                    header: null,
                    list: null,
                    indent: null
                }
            }
            this.placeHolder = 'To mention a user, type \'@\' and choose from the list of users';
        } else if (this.screen === 'communication_notes') {
            this.modulesMessage['toolbar'] = false;
            this.placeHolder = '';
        } else if(this.screen === 'call_note_template') {
            this.placeHolder = 'To create custom tags, type \'{\' and type your tag name and press enter';
        } else if (this.dialPad) {
            this.placeHolder = 'To use tags, type \'@\' and choose from the list of tags';
        }
        document.addEventListener('click', this.handleCellClick.bind(this));
    }
    onSelectTagHandler(item) {
        const denotationChar = item.denotationChar;
        this.editors.quillEditor.getModule('mention').insertItem(item, false)
        item.denotationChar = denotationChar;
        if(denotationChar === this.tagChar) {
            setTimeout(() => {
                let $mentionSpan = $('span.mention > span');
                let $mentionWrap = $('span.mention:not(.custom_tag)');
                this.editors.quillEditor.insertText(this.editors.quillEditor.getSelection(true), item.value + ' ');

                if ($mentionSpan.length > 0) {
                    $mentionWrap.remove();
                    setTimeout(() => {
                        const curPos = this.editors.quillEditor.getSelection(true);
                        this.editors.quillEditor.setSelection(curPos, -1)
                    }, 0);
                }
            }, 300);
        } else if(denotationChar === '{' && this.screen === 'call_note_template') {
            setTimeout(() => {
                let $mentionSpan = $('span.mention > span');
                let $mentionWrap = $('span.mention');
                if ($mentionSpan.length > 0) {
                    $mentionWrap.addClass('custom_tag');
                    setTimeout(() => {
                        const curPos = this.editors.quillEditor.getSelection(true);
                        this.editors.quillEditor.setSelection(curPos, -1)
                    }, 0);
                }
            }, 300);
        } else if (denotationChar === '@') {
            setTimeout(() => {
                let $mentionSpan = $('span.mention > span');
                let $mentionWrap = $('span.mention');
                $('span.mention').find('.ql-mention-denotation-char').remove()
                if ($mentionSpan.length > 0) {
                    $mentionWrap.addClass('user-style user-notes');
                    $mentionWrap.children().addClass('user-name');
                    let closeSection = $('<span></span>').addClass('close-icon');
                    let hasCloseIcon = $mentionWrap.find('.close-icon');
                    if ($mentionWrap.length == 1) {
                        if(hasCloseIcon.length == 0) {
                            $mentionWrap.children().append(closeSection);
                        }
                    } else {
                        for (let i = 0; i < $mentionWrap.length; i++) {
                            let $element = $($mentionWrap[i]);
                            let hasCloseIcon = $element.find('.close-icon');
                            if(hasCloseIcon.length == 0) {
                                $element.children().append(closeSection);
                            }
                        }
                    }
                    setTimeout(() => {
                        const curPos = this.editors.quillEditor.getSelection(true);
                        this.editors.quillEditor.setSelection(curPos, -1)
                    }, 0);
                }
            })
        }

    }

    blurHandler($event: { editor: any; source: string }) {
        const el = document.querySelector('.ql-tooltip [data-link]');
        if (!el) {
            return;
        }
        el.setAttribute('placeholder', 'http(s)://example.com');
        el.setAttribute('data-link', '');
    }

    onContentChanged(event) {
        this.contentChanged.emit(event);
        this.editorCreated(event);
    }

    editorCreated(event) {
        if(this.screen === 'call_note_template') {
            let $mentionWrap = $('span.mention:not(.custom_tag)');
            $mentionWrap.addClass('custom_tag');
        } else if (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'opportunity' || this.screen == 'scheduledActivities' || this.screen == 'customer') {
            let $mentionWrapCT = $('span.mention[data-value^="{"]');
            $mentionWrapCT.addClass('custom_tag');
            let mentionWrapUN = $('span.mention');
            mentionWrapUN.addClass('user-style user-notes');
            mentionWrapUN.children().addClass('user-name');
            if (mentionWrapUN.length === 1) {
                let $singleMention = mentionWrapUN.eq(0);
                let hasCloseIcon = mentionWrapUN.find('.close-icon');
                if($singleMention.find('.close-icon').length == 0) {
                    let closeSection = $('<span></span>').addClass('close-icon');
                    mentionWrapUN.children().append(closeSection);
                }
            } else {
                for (let i = 0; i < mentionWrapUN.length; i++) {
                    let $element = $(mentionWrapUN[i]);
                    let hasCloseIcon = $element.find('.close-icon');

                    if (hasCloseIcon.length === 0) {
                        let closeSection = $('<span></span>').addClass('close-icon');
                        $element.children().append(closeSection);
                    }
                }
            }
        }
    }

    handleCellClick(event){
        const mentionElement = (event.target as HTMLElement).closest('.mention');
        if (mentionElement) {
            mentionElement.remove();
        }
    }
}
